module.exports = __webpack_public_path__ + "static/media/redux.a65a699d.png";